import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import { client } from 'apollo';
import './index.scss';
import App from 'App';
import ScrollToTop from 'components/ScrollToTop';
import { ApolloProvider } from '@apollo/client/react/context';
import { TableProvider } from '@spins/react-table';
import { CampaignsProvider } from 'providers/campaigns';

declare global {
  interface Window {
    pendo: any;
  }
}

const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop />
      <ApolloProvider client={client}>
        <CampaignsProvider>
          <TableProvider>
            <App />
          </TableProvider>
        </CampaignsProvider>
      </ApolloProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
